export function setDeliveryAddresses({ state, action }) {
  return {
    ...state,
    deliveryAddresses: action.deliveryAddresses,
    addAddress: {
      ...state.addAddress,
      postcode: action.registrationPostcode || '',
    },
  };
}

export function setDeleteDeliveryAddressError({ state, action }) {
  return { ...state, deleteDeliveryAddressError: action.errorCode };
}

export function setOverrideDeliveryAddressError({ state, action }) {
  return { ...state, overrideDeliveryAddressError: action.errorCode };
}
